import { purple } from "../colors/index.js";
const newColor = (mode)=>'light' === mode ? {
        main: purple["500"],
        highContrast: purple["700"],
        lowContrast: purple["100"]
    } : {
        main: purple["400"],
        highContrast: purple["100"],
        lowContrast: purple["800"]
    };
export { newColor };

//# sourceMappingURL=new.js.map